var _defs, _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgTranscribe = function SvgTranscribe(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "transcribe_svg__Layer_1",
    width: 800,
    height: 800,
    "data-name": "Layer 1",
    viewBox: "0 0 24 24"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".transcribe_svg__cls-1{fill:none;stroke:#fff;stroke-miterlimit:10;stroke-width:1.92px}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M.5 3.35H12M6.25.48v2.87M9.12 3.35c0 3.52-3.28 8.2-7.66 10.55",
    className: "transcribe_svg__cls-1"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.51 7.37A16.4 16.4 0 0 0 11 13.9M12.96 22.52l3.83-10.54h.96l3.83 10.54M20.43 18.69h-5.36M11.04 22.52h3.84M19.67 22.52h3.83",
    className: "transcribe_svg__cls-1"
  })));
};
export default SvgTranscribe;